export default __webpack_public_path__ + "static/media/meucatalogo-card.3794c6e6.png";